import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IF from '@/components/IF';
import SoilSearchProperties from '@/components/SoilSearchProperties';
import { RootState } from '@/redux';
import { SoilProfileCloseIcon, SoilProfileWarningAlertIcon, SoilSearchClearIcon, SoilSearchStar } from '@/resource/IconComponentSets';
import { GetPropertyListResponseModel } from '@/util/Request/requestType';
import './index.less';
import { updateFourthTabValues, updateThirdTabValues } from '@/redux/reducer/soilSerach';
const { confirm } = Modal;

interface IProps {
    executeCallback: () => void
    // getSelectedPropertiesSet?: (selectedPropertySet: GetPropertyListResponseModel[]) => void
    clearButtonClick?: () => void
    saveQueryButtonClick?: () => void
}

const DrawOnMapTab = (props: IProps) => {
    const {
        executeCallback,
        // getSelectedPropertiesSet,
        clearButtonClick,
        saveQueryButtonClick
    } = props;

    const {
        drawPolyTabPropertiesSet,
        soilPropertyList
    } = useSelector((state: RootState) => state.soilSearchPageData);

    const dispatch = useDispatch();
    const [selectedProperty, setSelectedProperty] = useState<GetPropertyListResponseModel>();
    // const [selectedPropertySet, setSelectedPropertySet] = useState<GetPropertyListResponseModel[]>([]);
    const [noticeVisible, setNoticeVisible] = useState<boolean>(true);

    const handlePropertyListSelect = (record: GetPropertyListResponseModel) => {
        setSelectedProperty(record);
        let haveAdded = false;
        let chemicalAllTagAdded = false;
        let physicalAllTagAdded = false;

        drawPolyTabPropertiesSet.forEach((item) => {
            if (record.id === item.id) {
                haveAdded = true;
            }
            if (item.id === -10) {
                chemicalAllTagAdded = true;
            }
            if (item.id === -20) {
                physicalAllTagAdded = true;
            }
        });

        // duplicated selected item filter
        if (haveAdded) {
            return;
        }

        if ((record.category === 'Physical' && physicalAllTagAdded) || (record.category === 'Chemical' && chemicalAllTagAdded)) {
            return;
        }

        // normal selected handle method
        if (record.id === -10) {
            const newSelectedPropertySet = drawPolyTabPropertiesSet.filter((item) => item.category !== 'Chemical' || item.id === -20);
            dispatch(updateFourthTabValues({
                drawPolyTabPropertiesSet: [record, ...newSelectedPropertySet]
            }));
            // setSelectedPropertySet([record, ...newSelectedPropertySet]);
            return;
        }

        if (record.id === -20) {
            const newSelectedPropertySet = drawPolyTabPropertiesSet.filter((item) => item.category !== 'Physical' || item.id === -10);
            // setSelectedPropertySet([record, ...newSelectedPropertySet]);
            dispatch(updateFourthTabValues({
                drawPolyTabPropertiesSet: [record, ...newSelectedPropertySet]
            }));
            return;
        }

        const cachePropertySelectedList = [...drawPolyTabPropertiesSet];
        cachePropertySelectedList.push(record);
        // setSelectedPropertySet(cachePropertySelectedList);
        dispatch(updateFourthTabValues({
            drawPolyTabPropertiesSet: cachePropertySelectedList
        }));
    };

    const commomWarning = (message: string) => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: message,
            okText: 'OK',
            onCancel() {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const handleRemoveProperty = (removeItem: GetPropertyListResponseModel) => {
        const removedProperty = [];
        drawPolyTabPropertiesSet.forEach((item: GetPropertyListResponseModel) => {
            if (item.id !== removeItem.id) {
                removedProperty.push(item);
            }
        });
        dispatch(updateThirdTabValues({
            drawPolyTabPropertiesSet: removedProperty
        }));
    };

    return (
        <div className='draw-on-map-container'>
            <IF show={noticeVisible}>
                <div className='notice-in-container'>
                    <div className = 'up-div'>
                        <button onClick={() => setNoticeVisible(false)}>
                            <SoilProfileCloseIcon />
                        </button>
                    </div>
                    <div className='down-div'>
                        <div className='left-container'>
                            <SoilSearchStar />
                        </div>
                        <div className='right-container'>
                            <span>
                                Here you can draw polygon or circle selection. Use Rectangle or Circle buttons on the map to draw.
                            </span>
                        </div>
                    </div>
                </div>
            </IF>
            <h4>Soil Properties</h4>
            <SoilSearchProperties
                dataSource={soilPropertyList}
                selectedText={selectedProperty && selectedProperty.name}
                selectTargetPropertiesCallback={(record) => handlePropertyListSelect(record)}
            />
            <div className='soil-properties-tag'>
                <div className='inner-div'>
                    {drawPolyTabPropertiesSet.map((item) => (
                        <div className='property-tag' key={item.id}>
                            <span className={item.category === 'Chemical' ?
                                'chemical-categoty-span' : 'physical-category-span'}>
                                {item.category}
                            </span>
                            {item.name}
                            <button onClick={() => handleRemoveProperty(item)}>
                                <SoilSearchClearIcon className='close-icon-style' />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bottom-button-div'>
                <button className='clear-button' onClick={() => {
                    dispatch(updateFourthTabValues({
                        drawPolyTabPropertiesSet: []
                    }));
                    clearButtonClick();
                }}>
                    Clear
                </button>
                <div>
                    <button
                        className='clear-button'
                        onClick={saveQueryButtonClick}
                    >
                        Save Query
                    </button>
                    <button
                        className='fill-soil-properties'
                        onClick={() => {
                            if (drawPolyTabPropertiesSet.length > 0) {
                                executeCallback();
                            } else {
                                commomWarning('At least select one property!');
                            }
                        }}
                    >
                        {drawPolyTabPropertiesSet.length > 0 ? 'Execute' : 'Fill soil properties'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DrawOnMapTab;